import { apiRoutes } from 'config/apiRoutes'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import type { GendersRes } from 'features/genders/types/genders.types'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchGenders = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)
	const query = getCurrentQuery()

	const { data: genders, isPending: isGendersLoading } = useQuery<GendersRes>({
		queryKey: queryKeys.genders.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.genders(query ?? '')),
		enabled: !!auth.accessToken
	})

	return {
		genders,
		isGendersLoading
	}
}
